import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  DropFromSlotsToHomePayload,
  DropFromSlotsToSlotsPayload,
  ICard,
  ICardsRenderInfo,
  LaidSlotsDropPayload,
  RecordState,
  SuperMove,
} from '../../redux/types';
import { getPileX, getSlotY } from '../../utils/';
import SlotsCard from '../SlotsCard';
import { IDropElement } from '../../functions/hints';
import { dropFromSlotsToLaid, dropFromSlotsToSlots, dropFromSlotsToHome, setListening } from '../../redux/actions';
import { Dispatch } from 'redux';
import { superMoveSelector } from './selectors';
import SlotBorder from '../SlotBorder';

interface StateProps {
  cardParameters: ICardsRenderInfo;
  dropElements: IDropElement[];
  superMove: SuperMove | false;
  size: number;
}

interface StateActions {
  dropFromSlotsToLaid: (params: LaidSlotsDropPayload) => void;
  dropFromSlotsToSlots: (params: DropFromSlotsToSlotsPayload) => void;
  dropFromSlotsToHome: (params: DropFromSlotsToHomePayload) => void;
  setListening: (listening: boolean) => void;
}

interface Props extends StateProps, StateActions {
  index: number;
  card?: ICard | null;
}

class Slot extends Component<Props> {
  render() {
    const {
      cardParameters,
      index,
      card,
      dropElements,
      dropFromSlotsToSlots,
      dropFromSlotsToLaid,
      dropFromSlotsToHome,
      superMove,
      setListening,
      size,
    } = this.props;
    const { width, height, corner } = cardParameters;
    const x = getPileX(index, size);
    const y = getSlotY(size);

    return (
      <>
        <SlotBorder corner={corner} x={x} y={y} width={width} height={height} />
        {card !== undefined && card !== null && (
          <SlotsCard
            size={size}
            x={x}
            y={y}
            index={index}
            card={card}
            cardParameters={cardParameters}
            dropElements={dropElements}
            superMove={superMove}
            actions={{
              dropFromSlotsToLaid: dropFromSlotsToLaid,
              dropFromSlotsToSlots: dropFromSlotsToSlots,
              dropFromSlotsToHome: dropFromSlotsToHome,
              setListening: setListening,
            }}
          />
        )}
      </>
    );
  }
}

function mapStateToProps(state: RecordState, props: any): StateProps {
  return {
    cardParameters: state.get('cardsRenderInfo'),
    dropElements: state.get('dropElements'),
    superMove: superMoveSelector(state, props.index),
    size: state.get('size'),
  };
}

function mapDispatchToProps(dispatch: Dispatch): StateActions {
  return {
    dropFromSlotsToLaid: bindActionCreators(dropFromSlotsToLaid, dispatch),
    dropFromSlotsToSlots: bindActionCreators(dropFromSlotsToSlots, dispatch),
    dropFromSlotsToHome: bindActionCreators(dropFromSlotsToHome, dispatch),
    setListening: bindActionCreators(setListening, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Slot);
